import {ExporterComponent} from './ExporterComponent';
import {Router} from '@angular/router';
import {ServiceLocator} from '../../services/ServiceLocator';

export abstract class DefaultExporterComponent extends ExporterComponent {

    protected router: Router;

    protected constructor() {
        super();
        this.router = ServiceLocator.injector.get(Router);
    }

    getExportUrl(): string {
        return 'https://eiger.akceso.pro/verity/saveexcel/';
    }

    buildExportData(): any {
        const data = this.generateDataToTransfer();

        return {
            filename: 'export',
            headers: data.visibleKeys,
            module: this.router.url.substring(1),
            data: encodeURIComponent(JSON.stringify(data.dataToTransfer))
        };

    }

    protected generateDataToTransfer() {
        const visibleKeys = [];
        const dataToTransfer = [];
        this.tableColumns
            .filter(column => column.visible)
            .sort((a, b) => a.position - b.position)
            .forEach(column => visibleKeys.push(column.key));

        this.exportService.currentTableData.forEach(row => {
            const finalRow = {};

            visibleKeys.forEach(key => {
                const value = this.currencyConverterPipe.transform(row, key);
                if (value) {
                    finalRow[key] = value;
                } else {
                    finalRow[key] = '';
                }
            });

            dataToTransfer.push(finalRow);
        });
        return {
            visibleKeys: visibleKeys,
            dataToTransfer: dataToTransfer
        };
    }

    isExportAvailable(): boolean {
        return true;
    }
}
